/* eslint-disable import/prefer-default-export */
import axios from 'axios';

export function getErrorMessage(
  error,
  fallbackMessage = 'Something went wrong',
) {
  if (axios.isAxiosError(error)) {
    return (
      error?.response?.data?.message ||
      error?.response?.message ||
      error?.message ||
      String(error) ||
      fallbackMessage
    );
  }

  return error?.message || String(error) || fallbackMessage;
}
